import React, {FC, ReactNode} from 'react';
import {useInView} from 'react-intersection-observer';

interface IUseSliderItemInViewProps {
    id: string;
    index: number;
    onView: (id: string, index: number) => void;
    children: ReactNode;
    threshold?: number;
}

export const SliderItemInView: FC<IUseSliderItemInViewProps> = ({id, index, onView, children, threshold = 0.5}) => {
    const {ref} = useInView({
        triggerOnce: true,
        threshold,
        onChange: (inView) => {
            if (inView) {
                onView(id, index);
            }
        },
    });

    return <div ref={ref}>{children}</div>;
};
